import { AdvancedImage, lazyload } from '@cloudinary/react';
import { Cloudinary } from '@cloudinary/url-gen';
import { fill } from '@cloudinary/url-gen/actions/resize';

const CloudinaryPhoto = ({
  cloudName,
  publicId,
  width,
  height = 85,
  alt = '',
  className = '',
  rounded = false,
}) => {
  const cld = new Cloudinary({
    cloud: {
      cloudName,
    },
  });

  const myImage = cld.image(publicId);

  if (width && height) {
    myImage.resize(fill().width(width).height(height));
  } else if (width) {
    myImage.resize(fill().width(width));
  } else if (height) {
    myImage.resize(fill().height(height));
  }

  const classNames = `m-auto ${className} ${rounded ? 'rounded-full' : ''}`;
  return <AdvancedImage cldImg={myImage} className={classNames} alt={alt} />;
};

export default CloudinaryPhoto;
